<mat-toolbar class="custom-header">
  <span (click)="guiService.goTo('main/home')">
    <mat-icon svgIcon="mat:arrow_back"></mat-icon>
  </span>
</mat-toolbar>
<div class="container" *ngIf="video">
  <h2>{{video.i18nTitle[translate.currentLang.toUpperCase()] ? video.i18nTitle[translate.currentLang.toUpperCase()] :
    null}}</h2>
  <div class="video">
    <div class="img-container">
      <div class="locked" *ngIf="video.videoBlocked">
        <img src="../../assets/icon/Lucchetto.png" alt="" class="lock-icon">
      </div>
      <img *ngIf="video.videoId && video.videoId[translate.currentLang.toUpperCase()]"
        class="vidyard-player-embed"
        [src]="'https://play.vidyard.com/'+video.videoId[translate.currentLang.toUpperCase()]+'.jpg'"
        [attr.data-uuid]="video.videoId && video.videoId[translate.currentLang.toUpperCase()] ? video.videoId[translate.currentLang.toUpperCase()]: null"
        data-v="4" data-type="inline" />
    </div>
    <p>{{video.i18nDescription[translate.currentLang.toUpperCase()]}}</p>
  </div>

  <div class="footer-position">
    <span *ngIf="!video.videoBlocked">
      <button class="its-button mb-10" [class.disabled]="miniSpinnerPlay" *ngIf="video.pdf[translate.currentLang.toUpperCase()]"
        (click)="downloadPdf()">{{"ONDEMAND.DOWNLOAD_PDF" | translate}}</button>
      <button class="its-button" (click)="showVideo()" [class.disabled]="miniSpinnerPlay">
        <span *ngIf="!miniSpinnerPlay">{{"ONDEMAND.START" | translate}}</span>
        <ion-spinner name="circular" *ngIf="miniSpinnerPlay" style="height: 14px;"></ion-spinner>
      </button>
    </span>
    <span *ngIf="video.videoBlocked">
      <p>{{"ONDEMAND.UNLOCK_AREA" | translate}}</p>
      <button class="its-button" (click)="guiService.goTo('main/change-plan')">{{"ONDEMAND.UPGRADE" |
        translate}}</button>
    </span>
  </div>
</div>
